define( [
	"../var/support"
], function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/event/support.js
// module id = 2309
// module chunks = 36